export const SUBSCRIBE_URL = `https://email-newsletter.web.app/api/v1/subscribe`;
